import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaCloudUploadAlt } from "react-icons/fa";
import { ScaleLoader } from "react-spinners"; // Import ScaleLoader

function EditSubCategory() {
  const { catId } = useParams();
  const [categoryName, setCategoryName] = useState("");
  const [subCategoryName, setSubCategoryName] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  useEffect(() => {
    const fetchSubCategory = async () => {
      try {
        setIsLoading(true);
        const response = await USER_URL.get(`/categories/admin/subcategories/${catId}/`);
        console.log(response);
        
        const data = response.data.data;

        setCategoryName(data.category || "");
        setSubCategoryName(data.name || "");
        setPreview(data.image || null);
      } catch (error) {
        console.error("Error fetching subcategory:", error);
        toast.error("Failed to load subcategory.");
      } finally {
        setIsLoading(false);
      }
    };

    const fetchCategories = async () => {
      try {
        const response = await USER_URL.get(`/categories/admin/`);
        console.log(response.data.Data);
    
        if (Array.isArray(response.data.Data)) {
          setCategories(response.data.Data);
        } else {
          setCategories([]);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast.error("Failed to load categories.");
        setCategories([]);
      }
    };
    
    fetchSubCategory();
    fetchCategories();
  }, [catId]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!categoryName || !subCategoryName) {
      toast.warn("Please fill in all fields");
      return;
    }

    const formData = new FormData();
    formData.append("category", categoryName);
    formData.append("name", subCategoryName);
    if (image) formData.append("image", image);

    try {
      setIsSubmitting(true);
      
      const response = await USER_URL.patch(
        `/categories/admin/subcategories/${catId}/`, 
        formData, 
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.success("Subcategory updated successfully!");
      console.log("Response:", response.data);
    } catch (error) {
      console.error("Error updating subcategory:", error);
      toast.error(error.response?.data?.message || "Failed to update subcategory.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Show loading state while initial data is being fetched
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96">
        <ScaleLoader color="#FFAE00" size={40} />
      </div>
    );
  }

  return (
    <div className="p-3">
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="border-2 rounded-lg shadow-lg bg-white p-16 pt-8 w-full">
        <h2 className="text-green-600 text-3xl font-bold text-center mb-8 p-5">Edit Subcategory</h2>

        <form onSubmit={handleSubmit} className="flex items-start justify-between">
          {/* Image Upload Section */}
          <div className="flex flex-col w-1/2">
            <label className="text-md font-medium mb-2">Subcategory Image</label>
            <div className="w-44 h-44 border flex items-center justify-center rounded-lg overflow-hidden bg-gray-100">
              {preview ? (
                <img src={preview} alt="Preview" className="w-full h-full object-cover" />
              ) : (
                <span className="text-center text-gray-500 text-sm">No image selected</span>
              )}
            </div>
            <label className="flex items-center cursor-pointer text-white bg-blue-500 px-4 py-2 mt-3 w-44 rounded-md hover:bg-blue-600 text-sm">
              <FaCloudUploadAlt className="mr-2 text-lg" />
              {preview ? "Change Image" : "Upload Image"}
              <input 
                type="file" 
                onChange={handleImageChange} 
                className="hidden" 
                accept="image/*" 
              />
            </label>
          </div>

          {/* Category Name Dropdown and Subcategory Name Input */}
          <div className="flex flex-col w-1/2">
            <label className="text-md font-medium mb-2">Category Name</label>
            <select
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              className="border mb-5 px-3 py-2 rounded focus:outline-none focus:ring focus:ring-green-200"
            >
              <option value="">Select Category</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>

            <label className="text-md font-medium mb-2">Subcategory Name</label>
            <input
              type="text"
              value={subCategoryName}
              onChange={(e) => setSubCategoryName(e.target.value)}
              placeholder="Enter Subcategory name"
              className="border mb-5 px-3 py-2 rounded focus:outline-none focus:ring focus:ring-green-200"
            />

            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full bg-green-600 text-white py-2 rounded mt-4 transition ${
                isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-green-700"
              }`}
            >
              {isSubmitting ? (
                <div className="flex justify-center">
                  <ScaleLoader color="#ffffff" height={20} width={3} radius={2} margin={2} />
                </div>
              ) : "Update Subcategory"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditSubCategory;






// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { USER_URL } from "../../constant/api";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useParams, useNavigate } from "react-router-dom";

// function EditSubCategory() {
//   const { catId } = useParams();
//   const navigate = useNavigate();
//   const [categoryId, setCategoryId] = useState("");
//   const [subCategoryName, setSubCategoryName] = useState("");
//   const [image, setImage] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const [existingImage, setExistingImage] = useState("");
//   const [categories, setCategories] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);

//   // Fetch existing subcategory data and categories
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Fetch categories
//         const categoriesResponse = await USER_URL.get(`/categories/admin/`);
//         const categoriesData = categoriesResponse.data.Data || categoriesResponse.data;
//         setCategories(Array.isArray(categoriesData) ? categoriesData : []);

//         // Fetch subcategory data
//         const subCategoryResponse = await USER_URL.get(`/categories/admin/subcategories/${catId}`);
//         console.log(subCategoryResponse);
        
//         const subCategoryData = subCategoryResponse.data;
        
//         setCategoryId(subCategoryData.category?.id || "");
//         setSubCategoryName(subCategoryData.name || "");
//         setExistingImage(subCategoryData.image || "");
        
//         setIsLoading(false);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         toast.error("Failed to load data");
//         setIsLoading(false);
//       }
//     };

//     fetchData();
//   }, [catId]);

//   // Handle Image Upload
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImage(file);
//       setPreview(URL.createObjectURL(file));
//     }
//   };

//   // Form Submit Handler
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!categoryId || !subCategoryName) {
//       toast.warn("Please fill in all required fields");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("category", categoryId);
//     formData.append("name", subCategoryName);
//     if (image) {
//       formData.append("image", image);
//     }

//     try {
//       setIsSubmitting(true);
      
//       const response = await USER_URL.patch(
//         `/categories/admin/subcategories/${catId}/`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );

//       toast.success("Subcategory updated successfully!");
//       console.log("Response:", response.data);
      
//       // Navigate back or to another page after successful update
//       navigate("/admin/subcategories"); // Adjust to your route
//     } catch (error) {
//       console.error("Error updating subcategory:", error);
//       toast.error(error.response?.data?.message || "Failed to update subcategory.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (isLoading) {
//     return <div className="p-3">Loading...</div>;
//   }

//   return (
//     <div className="p-3">
//       <ToastContainer position="top-center" autoClose={3000} />
//       <div className="border-2 rounded-lg shadow-lg bg-white p-16 pt-8 w-full">
//         <h2 className="text-green-600 text-3xl font-bold text-center mb-8">Edit Subcategory</h2>

//         <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-8">
//           {/* Image Upload */}
//           <div className="flex flex-col">
//             <label className="text-md font-medium mb-2">Subcategory Image</label>
//             <div className="w-44 h-44 border flex items-center justify-center rounded-lg overflow-hidden bg-gray-100">
//               {preview ? (
//                 <img src={preview} alt="Preview" className="w-full h-full object-cover" />
//               ) : existingImage ? (
//                 <img src={existingImage} alt="Existing" className="w-full h-full object-cover" />
//               ) : (
//                 <span className="text-center text-gray-500 text-sm">No image selected</span>
//               )}
//             </div>
//             <input 
//               type="file" 
//               onChange={handleImageChange} 
//               className="mt-2 cursor-pointer" 
//             />
//             <p className="text-sm text-gray-500 mt-1">
//               {!image && "Leave empty to keep existing image"}
//             </p>
//           </div>

//           {/* Category and Subcategory Name */}
//           <div className="flex flex-col">
//             <label className="text-md font-medium mb-2">Category Name</label>
//             <select
//               value={categoryId}
//               onChange={(e) => setCategoryId(e.target.value)}
//               className="border mb-5 px-3 py-2 rounded focus:outline-none focus:ring focus:ring-green-200"
//               required
//             >
//               <option value="">Select Category</option>
//               {categories.map((category) => (
//                 <option key={category.id} value={category.id}>
//                   {category.name}
//                 </option>
//               ))}
//             </select>

//             <label className="text-md font-medium mb-2">Subcategory Name</label>
//             <input
//               type="text"
//               value={subCategoryName}
//               onChange={(e) => setSubCategoryName(e.target.value)}
//               placeholder="Enter Subcategory name"
//               className="border mb-5 px-3 py-2 rounded focus:outline-none focus:ring focus:ring-green-200"
//               required
//             />

//             <button
//               type="submit"
//               disabled={isSubmitting}
//               className={`w-full bg-green-600 text-white py-2 rounded mt-4 transition ${
//                 isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-green-700"
//               }`}
//             >
//               {isSubmitting ? "Updating..." : "Update Subcategory"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default EditSubCategory;

